/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpsertInitiativeDimensionScoreRequest
 */
export interface UpsertInitiativeDimensionScoreRequest {
    /**
     * 
     * @type {string}
     * @memberof UpsertInitiativeDimensionScoreRequest
     */
    dimensionKey: string;
    /**
     * 
     * @type {number}
     * @memberof UpsertInitiativeDimensionScoreRequest
     */
    weight?: number;
    /**
     * 
     * @type {number}
     * @memberof UpsertInitiativeDimensionScoreRequest
     */
    baselineScore?: number;
    /**
     * 
     * @type {number}
     * @memberof UpsertInitiativeDimensionScoreRequest
     */
    currentScore?: number;
    /**
     * 
     * @type {number}
     * @memberof UpsertInitiativeDimensionScoreRequest
     */
    targetScore?: number;
    /**
     * 
     * @type {string}
     * @memberof UpsertInitiativeDimensionScoreRequest
     */
    dataSource?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertInitiativeDimensionScoreRequest
     */
    notes?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpsertInitiativeDimensionScoreRequest
     */
    force?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpsertInitiativeDimensionScoreRequest
     */
    effectTenantId?: string;
}

/**
 * Check if a given object implements the UpsertInitiativeDimensionScoreRequest interface.
 */
export function instanceOfUpsertInitiativeDimensionScoreRequest(value: object): value is UpsertInitiativeDimensionScoreRequest {
    if (!('dimensionKey' in value) || value['dimensionKey'] === undefined) return false;
    return true;
}

export function UpsertInitiativeDimensionScoreRequestFromJSON(json: any): UpsertInitiativeDimensionScoreRequest {
    return UpsertInitiativeDimensionScoreRequestFromJSONTyped(json, false);
}

export function UpsertInitiativeDimensionScoreRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpsertInitiativeDimensionScoreRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'dimensionKey': json['dimensionKey'],
        'weight': json['weight'] == null ? undefined : json['weight'],
        'baselineScore': json['baselineScore'] == null ? undefined : json['baselineScore'],
        'currentScore': json['currentScore'] == null ? undefined : json['currentScore'],
        'targetScore': json['targetScore'] == null ? undefined : json['targetScore'],
        'dataSource': json['dataSource'] == null ? undefined : json['dataSource'],
        'notes': json['notes'] == null ? undefined : json['notes'],
        'force': json['force'] == null ? undefined : json['force'],
        'effectTenantId': json['effectTenantId'] == null ? undefined : json['effectTenantId'],
    };
}

export function UpsertInitiativeDimensionScoreRequestToJSON(json: any): UpsertInitiativeDimensionScoreRequest {
    return UpsertInitiativeDimensionScoreRequestToJSONTyped(json, false);
}

export function UpsertInitiativeDimensionScoreRequestToJSONTyped(value?: UpsertInitiativeDimensionScoreRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'dimensionKey': value['dimensionKey'],
        'weight': value['weight'],
        'baselineScore': value['baselineScore'],
        'currentScore': value['currentScore'],
        'targetScore': value['targetScore'],
        'dataSource': value['dataSource'],
        'notes': value['notes'],
        'force': value['force'],
        'effectTenantId': value['effectTenantId'],
    };
}

